export default {
  paged: {
    select: 'id,created,number,status,operationType,creator',
    searchSelect: ['number', 'creator'],
  },
  detail: {
    expand: {
      user: { select: 'fullName' },
      dependsOnTask: { select: 'number' },
    },
  },
};
